import { render } from "./FolderFilledIcon16.vue.js?vue&type=template&id=0ab850ae!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./FolderFilledIcon16.vue?vue&type=template&id=0ab850ae"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__